import React from 'react'

import SkeletonBox from '@/components/skeleton/SkeletonBox'

const CompanyProfileSkeleton: React.FC = () => (
  <>
    <div className="flex flex-col gap-2 px-4">
      <SkeletonBox style={{ height: '200px' }} />

      <div className="flex flex-col gap-2">
        <SkeletonBox style={{ height: '50px' }} />

        <div className="flex flex-col gap-4 md:flex-row">
          <div style={{ flex: 8 }}>
            <SkeletonBox style={{ height: '800px' }} />
          </div>

          <div style={{ flex: 4 }}>
            <SkeletonBox style={{ height: '800px' }} />
          </div>
        </div>
      </div>
    </div>
  </>
)

export default CompanyProfileSkeleton
